import React from 'react';
import {ReleaseBrowseCommon} from './ReleaseBrowseCommon';
import {PAGE_TITLE_BASE} from './../../constants.js';
import { Header, Segment, Grid, Message } from 'semantic-ui-react'

export function ReleaseBrowse(props) {
	document.title = 'Releases | ' + PAGE_TITLE_BASE;

	return (
		<div>
			<Segment inverted>
				<Header inverted as='h1' style={{textAlign:'center'}}>
					Browse Releases
				</Header>
			</Segment>
			<Grid>
				<Grid.Row>
					<Message warning style={{textAlign:'center'}}>
						<Message.Header><br/>This page only shows release infromation that has been human-reviewed.</Message.Header>
					</Message>
				</Grid.Row>
			</Grid>
			<ReleaseBrowseCommon urlParams={true}/>
		</div>
	);
}